import { GradeType } from '@shared/enums/grade-type';
import { ProductType } from '@shared/enums/product-type';
import { VariantType, VariantTypeIdentifier } from '@shared/enums/variant-type';
import { Helpers } from '@shared/helpers';
import { ViewerLanguage } from '@shared/viewer/enums/viewer-meta';

export namespace ViewerHelpers {
  export const componentIdFullPattern: RegExp = /^([a-z]{2,})([0-9]{4})([a-z]{0,})_(g[k0-9]-[k0-9]|g[0-9pk]+|abc|def|d|enac|sc|or|as|md|r|a|s)([a-z]{0,})_?.*$/i;

  export function mapComponentIdToViewerVariantType(componentId: string): VariantType {
    const variantMatches = componentId?.toLocaleLowerCase().match(Helpers.componentIdVariantPattern);
    let variantIdentifier = variantMatches && variantMatches.length === 6 ? `_${variantMatches[4]}` : '';
    if (variantIdentifier && variantMatches[5]) {
      variantIdentifier = `${variantIdentifier}${variantMatches[5]}`;
    }

    const variantType = VariantTypeIdentifier[variantIdentifier] || 'None';
    return VariantType[variantType];
  }


  export function mapComponentIdToVariantType(componentId: string): VariantType {
    const variantMatches = componentId.toLocaleLowerCase().match(Helpers.componentIdVariantPattern);
    let variantIdentifier = variantMatches && variantMatches.length === 6 ? `_${variantMatches[4]}` : '';
    if (variantIdentifier && variantMatches[5]) {
      variantIdentifier = `${variantIdentifier}${variantMatches[5]}`;
    }

    const variantTypeIdentifier = VariantTypeIdentifier[variantIdentifier] || 'None';
    const variantType = VariantType[variantTypeIdentifier];
    if (!componentId.includes('2025') && (variantType === VariantType.Grade2C || variantType === VariantType.Grade2M)) {
      // Grade2C and Grade2M assets are retrieved from the Grade2 folder.
      return VariantType.Grade2;
    }
    return variantType;
  }

  export function convertViewerLanguageForApiAssets(language: ViewerLanguage): ViewerLanguage {
    let convertedLanguage = language;
    if (language === ViewerLanguage.en) {
      convertedLanguage = ViewerLanguage.English;
    } else if (language === ViewerLanguage.es) {
      convertedLanguage = ViewerLanguage.Spanish;
    }
    return convertedLanguage;
  }

  export function getProductTypeByComponentId(componentId: string): ProductType {
    const componentIdLower = componentId ? componentId.toLocaleLowerCase() : '';
    const componentSegments = componentIdLower.split('_').map(s => s.toLocaleUpperCase());
    if (componentSegments && componentSegments.length > 0) {
      return ProductType[componentSegments[0]?.toLocaleLowerCase()]
        ? ProductType[componentSegments[0].toLocaleLowerCase()]
        : ProductType.None;
    }
    return ProductType.None;
  }

  export function isSuperkidsProduct(productType: ProductType): boolean {
    return productType === ProductType.sk2015
      || productType === ProductType.sk2017
      || productType === ProductType.sk2026
      || productType === ProductType.fsk2021
      || productType === ProductType.hea2011;
  }

  export function removeMarkupFromText(text: string): string {
    return text.replace(/<\/?[^>]+(>|$)/g, '');
  }

  /** gets GradeType enum for a given grade string for the asset Viewer */
  export function mapGradeToGradeTypeForViewer(grade: string): GradeType {
    const key = `Grade${grade?.toUpperCase()}`;
    if (key != null && GradeType[key]) {
      return GradeType[key];
    }
    if (grade === 'pk') {
      return GradeType.GradePreK;
    }
    return GradeType.None;
  }

  export function getGradeType(grade: string): GradeType {
    if (GradeType[grade]) {
      return GradeType[grade];
    }
    return grade === 'None' ? GradeType.None : GradeType.UnknownGrade;
  }
}
